// extracted by mini-css-extract-plugin
export default {"wrapper":"search-block-module--wrapper--38915","innerWrapper":"search-block-module--innerWrapper--e877a"};